export default {
  data() {
    return {
      listener: null,
    };
  },
  methods: {
    clickOutside(method, node = '', callback = () => ('')) {
      if (!this.listener) {
        this.listener = function (e) {
          if (node instanceof Array) {
            const clickList = node.map((item) => !e.composedPath().includes(item));
            const hasClickedOutside = !clickList.includes(false);

            if (hasClickedOutside) {
              callback();
            }
          } else if (!e.composedPath().includes(node)) {
            callback();
          }
        };
      }

      switch (method) {
        case 'add':
          document.addEventListener('click', this.listener);
          break;
        case 'remove':
          document.removeEventListener('click', this.listener);
          break;

        default:
          document.removeEventListener('click', this.listener);
          break;
      }
    },
  },
};
